import { Component, ErrorInfo, PropsWithChildren, ReactNode } from "react";

type ErrorData = { error: Error; errorInfo: ErrorInfo };
type FallbackRenderer = (errorData: ErrorData) => ReactNode;

type ErrorBoundaryProps = PropsWithChildren<{
  fallback: ReactNode | FallbackRenderer;
}>;
type ErrorBoundaryState = { errorData: ErrorData | undefined };

export default class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  private static initialState: ErrorBoundaryState = { errorData: undefined };
  public state: ErrorBoundaryState = ErrorBoundary.initialState;

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    this.setState({ errorData: { error, errorInfo } });
  }

  public reset(): void {
    this.setState(ErrorBoundary.initialState);
  }

  public render(): ReactNode {
    if (this.state.errorData == null) return this.props.children;
    if (typeof this.props.fallback !== "function") return this.props.fallback;
    return this.props.fallback(this.state.errorData);
  }
}
